import FieldMixins from './mixins/field_mixin.js';

const LOCATION_ADJUST_RADIUS = [null, 100, 200, 500, 1000, 0]; // null为关闭， 0为无限制

export default Vue.extend({
  mixins: [FieldMixins],

  data() {
    return {
      adjustRadiusOptions: LOCATION_ADJUST_RADIUS,
    };
  },

  template: `
    <FieldView :editing='editing'
               :field='field'
               :field_groups='field_groups'
               :layouts='availableLayouts'
               ref='fieldView'>
      <template slot='content'>
        <div class="edit-content" v-if='editing'>
          <div class="map-description-panel adjust-radius-panel">
            <div class="label">位置微调范围</div>
            <div class="description">可在微调范围内，修改实时(GPS/IP)定位地址</div>
            <Dropdown customClass="adjust-radius-dropdown-select"
                      placeholder='关闭'
                      :optionGroups='[{ options: adjustRadiusOptions }]'
                      :initValue='field.settings.adjust_radius'
                      @change='adjustRadiusChanged'>
              <template slot='value-template' slot-scope='{ option }'>
                <span>{{ _getLocationAdjustRadiusText(option) }}</span>
              </template>
              <template slot='option-template' slot-scope='{ option }'>
                <span>{{ _getLocationAdjustRadiusText(option) }}</span>
              </template>
            </Dropdown>
          </div>
          <div class='map-description-panel'>
            <div class="label">设置定位和范围</div>
            <div class="justify-between">
              <span class="description">实时(GPS/IP)定位地址在指定地点的有效范围内，才算定位生效</span>
              <button class='btn btn-small btn-default' @click='clearMarker'>清除限定</button>
            </div>
          </div>
          <div id="map_container" class='map-container' ref='mapContainer'></div>
          <div ref='queryContainer' class='map-query-container'>
            <input type="text" class='floated' id="js_map_query_input" placeholder='输入查询地址'/>
          </div>
        </div>
        <div class="display-content" v-else>
          <button class="btn btn-default">
            <span>点击定位</span>
            <i class="slp-map-marker"></i>
          </button>
        </div>
      </template>
    </FieldView>
  `,

  watch: {
    editing(newValue) {
      if (newValue) {
        this.$nextTick(() => {
          this._initMap();
        });
      }
    },
  },

  methods: {
    updatePoint(position, name) {
      this.field.longitude = position[0];
      this.field.latitude = position[1];
      this.field.remark = name;
    },

    updateDistance(radius) {
      this.field.max_distance = radius;
    },

    clearMarker() {
      this._clearMarker(this._map);
      this._clearCircle(this._map);
      this.updatePoint([null, null], null);
      this.updateDistance(null);
    },

    adjustRadiusChanged(radius) {
      this.field.settings.adjust_radius = radius;
    },

    _initMap() {
      const initPos = this._getInitPos();
      if (!(AMap && AMap.Map)) {
        console.log('地图插件载入失败');
      }
      const map = this._setMap(initPos);
      this._addToolbar(map);
      map._marking = false;
      this.$refs.mapContainer.appendChild(this.$refs.queryContainer);
      this._bindClickEvent(map);
      if (initPos != null) this._addMarker(map, initPos, this.field.remark);
      this._initQuery(map);
    },

    _initQuery(map) {
      map.plugin('AMap.Autocomplete', () => {
        const auto = new AMap.Autocomplete({ input: 'js_map_query_input' });
        const resultContainer = document.querySelector('.amap-sug-result');
        resultContainer.addClass('map-query-results');
        this.$refs.queryContainer.appendChild(resultContainer);
        AMap.event.addListener(auto, 'select', (event) => {
          if (event.poi && event.poi.location) {
            map.setCenter(event.poi.location);
            this._addMarker(map, [event.poi.location.lng, event.poi.location.lat], event.poi.district + event.poi.name);
          }
        });
      });
    },

    _bindClickEvent(map) {
      map.on('click', (event) => {
        const lng = event.lnglat.getLng();
        const lat = event.lnglat.getLat();
        this._addMarker(map, [lng, lat]);
      });
    },

    _addMarker(map, position, remark) {
      if (map._marking) return;
      this._displayCircle(map, position);
      map._marking = true;
      if (remark) {
        this._displayMarker(map, position, remark);
        map._marking = false;
        map.setFitView([map._circle]);
      } else {
        this._displayMarker(map, position, '解析地址中...');
        const geolocation = new Skylark.Libs.Geolocation({
          position: {
            longitude: position[0],
            latitude: position[1],
            type: 'wgs84',
          },
        });
        geolocation.getRegeocode((_error, regeocode) => {
          map._marking = false;
          if (_error || _.isArray(regeocode.formattedAddress)) {
            this._displayMarker(map, position, '解析失败的地理位置');
          } else {
            this._displayMarker(map, position, regeocode.formattedAddress);
          }
        });
      }
    },

    _clearMarker(map) {
      if (map._marker != null) {
        map._marker.setMap(null);
        map._marker = null;
      }
    },

    _displayMarker(map, position, name) {
      this._clearMarker(map);
      map._marker = new AMap.Marker({
        position,
        title: name,
        icon: 'https://webapi.amap.com/theme/v1.3/markers/n/mark_b.png',
      });
      map._marker.setLabel({
        offset: new AMap.Pixel(-100, 40),
        content: name,
      });
      map._marker.setMap(map);
      this.updatePoint(position, name);
    },

    _clearCircle(map) {
      if (map._circle_editor) {
        map._circle_editor.close();
        map._circle_editor = null;
      }
      if (map._circle) {
        map._circle.setMap(null);
        map._circle = null;
      }
    },

    _displayCircle(map, position) {
      this._clearCircle(map);
      if (this.field.max_distance == null) this.field.max_distance = 200;
      map._circle = new AMap.Circle({
        map,
        center: new AMap.LngLat(position[0], position[1]),
        radius: this.field.max_distance,
        strokeColor: '#2196f3',
        strokeOpacity: 0.8,
        strokeWeight: 1,
        fillColor: '#2196f3',
        fillOpacity: 0.3,
      });

      map.plugin('AMap.CircleEditor', () => {
        map._circle_editor = new AMap.CircleEditor(map, map._circle);
        map._circle_editor.open();
        AMap.event.addListener(map._circle_editor, 'move', (event) => {
          this._clearMarker(map);
          const position = [event.lnglat.getLng(), event.lnglat.getLat()];
          const fn = () => {
            this.updatePoint(position, '');
            this._addMarker(map, position, this.field.remark);
          };
          this._delay(`point${this.field.position}`, fn);
        });
        AMap.event.addListener(map._circle_editor, 'adjust', (event) => {
          this._delay(`distance${this.field.position}`, () => {
            this.updateDistance(event.radius);
          });
        });
      });
    },

    _delay(id, fn, delay = 1000) {
      Skylark.Helpers.Utilities.hysteresis(fn, id, delay);
    },

    _setMap(pos) {
      this._map = new AMap.Map('map_container', {
        zoom: 16,
        resizeEnable: true,
        center: pos,
      });
      return this._map;
    },

    _addToolbar(map) {
      map.plugin('AMap.ToolBar', () => {
        const toolbar = new AMap.ToolBar({ visible: true, ruler: false, direction: false });
        map.addControl(toolbar);

        AMap.event.addListener(toolbar, 'location', (event) => {
          const position = [event.lnglat.getLng(), event.lnglat.getLat()];
          this.updatePoint(position, '');
          this._addMarker(map, position, this.field.remark);
          map.setFitView([map._circle]);
        });
      });
    },

    _getInitPos() {
      const lng = this.field.longitude;
      const lat = this.field.latitude;
      if (!(lng && lat)) return undefined;
      return [parseFloat(lng), parseFloat(lat)];
    },

    _getLocationAdjustRadiusText(radius) {
      switch (radius) {
        case null:
          return '关闭';
        case 0:
          return '无限制';
        default:
          return `${radius}米`;
      }
    },
  },
});
